<script setup lang="ts">
  import { now } from '@/stores/EventStore'
  import { ref, watch, computed } from 'vue'

  const props = defineProps<{
    route?: string
    isWhite?: boolean
    size?: number
    timeoutSeconds?: number
  }>()

  const TIMEOUT_SECONDS = props.timeoutSeconds ?? 30
  const emit = defineEmits<{
    timeout: []
  }>()
  const remainingSeconds = ref(TIMEOUT_SECONDS)
  let timerStopped = false

  function resetTimer() {
    remainingSeconds.value = TIMEOUT_SECONDS
    timerStopped = false
  }
  watch(props, () => {
    resetTimer()
  })

  watch(now, () => {
    if (!timerStopped) {
      if (props.route && props.route !== history.state.current) {
        return
      }
      if (remainingSeconds.value <= 0) {
        timerStopped = true
        emit('timeout')
        return
      }
      remainingSeconds.value--
    }
  })

  const progress = computed(() => {
    return Math.round((remainingSeconds.value / TIMEOUT_SECONDS) * 100)
  })

  defineExpose({ resetTimer })
</script>
<template>
  <div
    appium="exitTimer"
    class="p-2 rounded-full"
    :class="{ 'bg-white': !props.isWhite }"
  >
    <div class="rounded-full items-center justify-center flex relative">
      <ve-progress
        :size="props.size ?? 30"
        :progress="progress"
        :color="props.isWhite ? '#ffffff' : '#1f2937'"
        :empty-color="'transparent'"
        :reverse="true"
        :thickness="props.isWhite && props.size && props.size >= 50 ? 5 : 2"
        animation="default 0 0"
      >
        <template #default>
          <div></div>
        </template>
      </ve-progress>
      <div class="w-full h-full flex items-center justify-center absolute">
        <font-awesome-icon
          :class="{
            'text-gray-800 text-xl': !props.isWhite,
            'text-white text-xl md:text-3xl': props.isWhite,
          }"
          icon="fa-solid fa-xmark"
        />
      </div>
    </div>
  </div>
</template>
